export const appId = 130444; // v站appid
export const subQuestionSortNumProjectIds = [106, 120, 68]; // 启用小题算大题的项目
